import { NgModule } from '@angular/core';
import { provideRouter, RouterModule, withComponentInputBinding, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { routes } from './app.routes';

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    bindToComponentInputs: true,
    onSameUrlNavigation: 'reload',
  })],
  exports: [RouterModule],
  providers: [
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled', //@todo: use this to tweak scrolling behavior
      }),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      })
    ),
  ]
})
export class AppRoutingModule {}
